<template>
  <div class="calcTabs">
    <div
      v-for="tab in $store.state.packageAll"
      :key="tab.license"
      class="calcTabs__tab"
      :class="{ 'calcTabs__tab--active': tab.license === $store.state.package.license }"
      @click="() => setLicense(tab.license)"
    >
      {{ tab.licenseNameShort }}
    </div>
  </div>
</template>

<script>
export default {
  name: "CalcTabs",
  methods: {
    setLicense(val) {
      const index = this.$store.getters.licenseAll.findIndex(i => i.code === val)
      this.$store.commit('setPackage', this.$store.state.packageAll[index])
    }
  }
};
</script>

<style lang="scss" scoped>
.calcTabs {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  @media (min-width: $breakpoint-xl) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  &__tab {
    border: 2px solid $color-primary;
    border-radius: 6px;
    color: rgba(0, 0, 0, 0.87);
    cursor: pointer;
    font-family: $font-secondary;
    font-size: 12px;
    line-height: 16px;
    padding: 6px;
    text-align: center;
    transition: 0.2s;

    &:hover,
    &--active {
      background-color: $color-primary;
      color: #fff;
    }
  }
}
</style>
